module.exports = __webpack_public_path__ + "img/RU.18c20b3d.png";